import type React from 'react';
import lockIcon from '@/assets/icons/lock.png';
import { ActionButton, LoadingSpinner } from '@/components/atoms/primitives';
import { AuthFormLayout, FormField } from '@/components/molecules';
import { SignUpStage, type StageProps } from '../types';

export const PasswordStage: React.FC<StageProps> = ({ form, setForm, setStage, error, setError, loading, onNext }) => {
  const handleSignUp = () => {
    const hasNumber = /\d/;
    // eslint-disable-next-line no-useless-escape
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
    const hasUppercase = /[A-Z]/;
    const hasLowercase = /[a-z]/;

    const validatePassword =
      hasNumber.test(form.password) &&
      hasSpecialChar.test(form.password) &&
      hasUppercase.test(form.password) &&
      hasLowercase.test(form.password);

    if (validatePassword && form.password === form.confirmPassword) {
      setError(false);
      onNext?.(); // This triggers the start of signUp process in parent/hook
    } else {
      if (!validatePassword && form.password !== form.confirmPassword) {
        setError('Invalid password and password do not match');
      } else {
        if (!validatePassword) {
          setError('Invalid password');
        } else if (form.password !== form.confirmPassword) {
          setError('Passwords do not match');
        }
      }
    }
  };

  if (loading) {
    return (
      <div className="flex w-1/2 p-16 flex-col justify-center items-center bg-[#0a0e1a] text-white">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <AuthFormLayout title="Sign Up" error={error}>
      <div className="text-xs text-gray-400 mb-2">
        Your password must be at minimum 8 characters long and must contain at least 1 number, special character,
        uppercase letter, and lowercase letter.
      </div>

      <FormField
        label="Password"
        type="password"
        value={form.password}
        onChange={(value) => setForm({ ...form, password: value })}
        placeholder="password"
        icon={lockIcon}
        iconAlt="Lock icon"
        fullWidth
      />

      <FormField
        label="Confirm Password"
        type="password"
        value={form.confirmPassword}
        onChange={(value) => setForm({ ...form, confirmPassword: value })}
        placeholder="password"
        icon={lockIcon}
        iconAlt="Lock icon"
        fullWidth
      />

      <ActionButton
        type="button"
        onClick={handleSignUp}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-200 mt-4"
      >
        Create Account
      </ActionButton>

      <div className="text-center mt-4">
        <button
          type="button"
          className="text-blue-400 hover:text-blue-300 text-sm"
          onClick={() => setStage(SignUpStage.PERSONAL_DETAILS)}
        >
          Back to personal details
        </button>
      </div>
    </AuthFormLayout>
  );
};
